module.exports = __webpack_public_path__ + "static/media/Article_1_crea_v2.e0cff7b8.png";